module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/vkovalcuk29239528-avatar-f4b42e13dc0571ab0a07da2ac880e475.jpg";